import gsap from 'gsap';
import { getPosts } from '../components/getPosts';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
const $ = jQuery;
const $section = $('section.team-archive');
const postContainer = $section.find('.js-archive--posts');
const $filters = $section.find('.js-radio-filters__item input[type="radio"]');

export default function () {
    if (!$section.length) return;

    handleRadioFilters();
    handleFiltersButton();
    handleFiltersButtonScroll();
}

const handleRadioFilters = () => {
    if (!$filters.length) return;

    $filters.on('change', function () {
        handlePosts();
    });
};

const handlePosts = () => {
    const data = {
        action: 'get_team',
        taxonomies: getActiveFilterData(),
    };

    getPosts(data, handlePostsBefore, handleSuccess);
};

const handlePostsBefore = () => {
    postContainer.addClass('loading');
};

const handleSuccess = (data) => {
    data = JSON.parse(data);
    const $posts = $section.find('.js-archive--posts');

    if (!data.posts) {
        $posts.html('');
    } else {
        $posts.html(data.posts);
    }

    postContainer.removeClass('loading');

    ScrollTrigger.refresh();
};

const getActiveFilterData = () => {
    const filters = [];
    $section.find('.js-radio-filters__item input[type="radio"]:checked').each(function () {
        const $filter = $(this);
        const name = $filter.attr('name');
        const value = $filter.val();

        filters.push({ name, value });
    });

    return filters;
};

const handleFiltersButton = () => {
    const $button = $section.find('.js-archive-filters-button');
    const $filters = $section.find('.js-radio-filters');

    $button.on('click', function () {
        const parent = $(this).closest('.team-archive__filters');
        parent.toggleClass('open');
        $filters.slideToggle();
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.team-archive__filters').length && window.innerWidth < 1024) {
            $('.team-archive__filters').removeClass('open');
            $filters.slideUp();
        }
    });
};

const handleFiltersButtonScroll = () => {
    const $filtersBlock = $section.find('.team-archive__filters');
    const $radioFiltersContainer = $filtersBlock.find('.js-radio-filters');
    if (!$filtersBlock.length) return;

    $section.css('position', 'relative');

    ScrollTrigger.matchMedia({
        '(max-width: 1023px)': function () {
            const triggerDisabled = ScrollTrigger.create({
                trigger: $section,
                start: 'top center',
                id: 'trigger-disabled-mobile',
                onEnter: () => {
                    $filtersBlock.removeClass('disabled');
                },
                onLeaveBack: () => {
                    $filtersBlock.addClass('disabled');
                },
            });

            const triggerUnpinned = ScrollTrigger.create({
                trigger: $section,
                start: 'top bottom',
                end: 'bottom bottom',
                id: 'trigger-unpinned-mobile',
                onLeave: () => {
                    $filtersBlock.addClass('is-unpinned');
                },
                onEnterBack: () => {
                    $filtersBlock.removeClass('is-unpinned');
                },
            });

            return () => {
                triggerDisabled?.kill();
                triggerUnpinned?.kill();
                $filtersBlock.removeClass('disabled is-unpinned');
            };
        },

        '(min-width: 1024px)': function () {
            $filtersBlock.removeClass('disabled is-unpinned');
        },
    });

    ScrollTrigger.refresh();

    $(window).on('scroll', function () {
        if ($filtersBlock.hasClass('open')) {
            $filtersBlock.removeClass('open');
            $radioFiltersContainer.slideUp();
        }
    });
};
